import { ReactNode } from 'react';
import { INavItemData } from '@/creditflowresearch/ui/common/constants/panelData';
import PanelTools from '@/creditflowresearch/ui/common/components/organisms/PanelTools';
import { PanelLayoutDesktop } from '@/creditflowresearch/ui/common/components/templates/PanelLayout';
import { SectionLayoutDesktop } from '@/creditflowresearch/ui/common/components/templates/SectionLayout';
import { IToolLinkOption } from '@/creditflowresearch/domain/vo/ITools';
import { ISection } from '@creditflowresearch/uilib/Section';
import type { ExpandStrategy } from '@/creditflowresearch/domain/Header/Section/expandStrategy';

interface IPanelTemplateDesktopProps {
  panelData: INavItemData,
  headerPanel: ReactNode,
  topOptions: IToolLinkOption[],
  toolsOptions: IToolLinkOption[],
  sectionsGrid: ISection[][][],
  expandStrategy?: ExpandStrategy,
}

const PanelTemplateDesktop = ({
  panelData,
  headerPanel,
  topOptions,
  toolsOptions,
  sectionsGrid,
  expandStrategy,
}: IPanelTemplateDesktopProps) => (
  <PanelLayoutDesktop
    headerPanel={ headerPanel }
    leftContent={ (
      <PanelTools
        topOptions={ topOptions }
        toolsOptions={ toolsOptions }
        title={ `Tools (${ panelData.abbreviation })` }
      />
    ) }
    rightContent={ (
      <SectionLayoutDesktop
        title={ panelData.sectionsTitle }
        sectionsGrid={ sectionsGrid }
        expandStrategy={ expandStrategy }
      />
    ) }
  />
);

export default PanelTemplateDesktop;
